import React from 'react';

import { NEWS_RSS_FEED_LINK } from '../../constants';
import * as s from './PostRssFeedLink.css';

/**
 * Ссылка на rss-фид
 */
export const PostRssFeedLink = () => (
  <a className={s['rss']} href={NEWS_RSS_FEED_LINK} target={'_blank'} rel="noreferrer">
    RSS
  </a>
);
